<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="18.106"
		height="13.634"
		viewBox="0 0 18.106 13.634"
	>
		<defs>
			<clipPath id="clip-path-EyeSvg">
				<rect id="Rectangle_8434" data-name="Rectangle 8434" width="17.264" height="12.875" fill="none" stroke="#6b7786" stroke-width="1" />
			</clipPath>
		</defs>
		<g id="Group_27665" data-name="Group 27665" transform="translate(-4.579 0.379)">
			<g id="Group_27663" data-name="Group 27663" transform="translate(5 0)">
				<path
					id="Path_20616"
					data-name="Path 20616"
					d="M9.011.75a9.345,9.345,0,0,0-7.9,4.8,2.41,2.41,0,0,0,0,2.534,9.346,9.346,0,0,0,7.9,4.8,9.346,9.346,0,0,0,7.9-4.8,2.412,2.412,0,0,0,0-2.534A9.338,9.338,0,0,0,9.011.75Z"
					transform="translate(-0.38 -0.38)"
					fill="none"
					stroke="#6b7786"
					stroke-miterlimit="10"
					stroke-width="1.5"
				/>
				<g id="Group_27659" data-name="Group 27659" transform="translate(0 0)" opacity="0.99">
					<g id="Group_27658" data-name="Group 27658" transform="translate(0 0)">
						<g id="Group_27657" data-name="Group 27657" clip-path="url(#clip-path-EyeSvg)">
							<path
								id="Path_20617"
								data-name="Path 20617"
								d="M16.913,8.084a9.345,9.345,0,0,1-7.9,4.8,9.345,9.345,0,0,1-7.9-4.8,2.41,2.41,0,0,1,0-2.534,9.345,9.345,0,0,1,7.9-4.8,9.339,9.339,0,0,1,7.9,4.8A2.41,2.41,0,0,1,16.913,8.084Z"
								transform="translate(-0.38 -0.38)"
								fill="none"
								stroke="#6b7786"
								stroke-miterlimit="10"
								stroke-width="1.5"
							/>
						</g>
					</g>
				</g>
				<g id="Group_27662" data-name="Group 27662" transform="translate(5.783 3.589)" opacity="0.99">
					<g id="Group_27661" data-name="Group 27661">
						<g id="Group_27664" data-name="Group 27664">
							<circle
								id="Ellipse_438"
								data-name="Ellipse 438"
								cx="2.478"
								cy="2.478"
								r="2.478"
								transform="translate(0.37 0.37)"
								fill="none"
								stroke="#6b7786"
								stroke-miterlimit="10"
								stroke-width="1.5"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'EyeSvg',
};
</script>

<style scoped lang="scss"></style>
